<template>
  <div class="course-detail-edite-wrap">
    <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);padding:30px 20px;">
      <!-- <div class="course-detail-img">
        <img :src="couseCoverUrl" alt="">
      </div> -->
      <div class="course-detail-info">
        <div class="course-detail-name">{{ hourInfo.chName }}</div>
        <div class="course-detail-desc">
          <!-- <span >{{chCount}}</span>
            <span class="space-span-right">人在学</span>| -->
          <span class="space-span-left">直播时间:{{ hourInfo.chStartDate }} ~ {{ hourInfo.chEndDate||'' }}</span>
          <!--<span>{{chapterCount?chapterCount:0}}</span>
            <span>个章节 </span>
            <span class="">{{chCount?chCount:0}}</span>
            <span class="space-span-right">个课时</span>
            <!-- <span class="space-span-left">更新中</span> -->
        </div>
      </div>
      <!-- <div class="course-detail-right">
          <a-button @click="editeCourse()" type="primary" style="margin-left:8px;">编辑</a-button>
        </div> -->
    </a-card>
    <a-card :bordered="false" style="margin-top:10px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);padding:10px;">
      <div class="total-data">
        <div class="total-data-item">
          <div class="p1">观看人数(UV)</div>
          <div class="p2">{{ memberCount || '-' }}</div>
        </div>
        <div class="total-data-item">
          <div class="p1">观看人次(PV)</div>
          <div class="p2">{{ totalCount || '-' }}</div>
        </div>
        <div class="total-data-item">
          <div class="p1">人均观看时长</div>
          <div class="p2">{{ avgSec || '-' }}</div>
        </div>
      </div>
    </a-card>
    <a-card :bordered="false" style="margin-top:10px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
      <a-tabs defaultActiveKey="1" >
        <a-tab-pane tab="学员名单" key="1">
          <OnlineUserList :courseId="courseId"></OnlineUserList>
        </a-tab-pane>
        <!-- <a-tab-pane tab="学员管理" key="2" forceRender>
            <CourseStudentsManage></CourseStudentsManage>
          </a-tab-pane> -->
        <!--<a-tab-pane tab="课程评价" key="2">
            <CourseRatingManage></CourseRatingManage>
          </a-tab-pane>-->
        <a-tab-pane tab="讨论" key="3">
          <OnlineUserTalkList></OnlineUserTalkList>
        </a-tab-pane>
        <!-- <a-tab-pane tab="学习资料" key="5">Content of Tab Pane 5</a-tab-pane> -->

      </a-tabs>
    </a-card>
    <!-- <a-card :bordered="false" style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">

      </a-card> -->

  </div>

</template>

<script>

  import OnlineUserList from '../../components/onlineVideo/onlineVideoInfo/OnlineUserList'
  import OnlineUserTalkList from '../../components/onlineVideo/onlineVideoInfo/OnlineUserTalkList'

  import { liveRoomFlow } from '@/api/api'
  export default {
    name: 'CourseDetailEdite',
    components: { OnlineUserList, OnlineUserTalkList },
    mixins: [],
    data() {
      return {
        courseName: '', // 课程名称
        price: '', // 课程加个
        chapterCount: '', // 章节数
        couseCoverUrl: '', // 封面
        chCount: '', // 课时数
        avgSec: '',
        memberCount: '',
        totalCount: '',
        chId: '',
        hourInfo: {}
      }
    },
    created() {
      this.chId = this.$route.query.chId
      this.getData()
    },
    methods: {
      getData() {
        liveRoomFlow({ chId: this.chId, pageNo: '1', pageSize: 10 }).then((res) => {
          if (res.success) {
            this.memberCount = res.result.cnt.memberCount
            this.totalCount = res.result.cnt.totalCount
            this.avgSec = res.result.cnt.avgSec
            this.hourInfo = res.result.hourInfo || {}
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {

        })
      }

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
  .course-detail-edite-wrap{

    .total-data {
    .total-data-item {
      float: left;
      width: 33.33%;
      margin: 25px 0px;
      border-right: 1px solid #e7ecef;
      &:last-child {
        border-right: none;
      }
      .p1 {
        text-align: center;
        font-size: 14px;
        color: #333333;
      }
      .p2 {
        text-align: center;
        color: #fa6400;
        font-size: 40px;
      }
    }
  }

    .course-detail-img{
      float:left;
      width:132px;
      height:86px;
      img{
        width:100%;
      }
    }
    .course-detail-info{
      float:left;
      margin-left:14px;
      .course-detail-name{
        color:#333333;
        margin-bottom:5px;
        font-weight: bold;
      }
      .course-detail-price{
        color:#FA6400;
        font-size:14px;
      }
      .course-detail-desc{
        color:#999999;
        font-size:12px;
        margin-top:16px;
        .space-span-left{
          // padding-left:5px;
        }
        .space-span-right{
          padding-right:5px;
        }
      }
    }
    .course-detail-right{
      float:right;
    }

    .info-title{
      border-bottom: 1px solid #E7ECEF;
      line-height: 50px;
      height: 50px;
      padding-left: 25px;
    }

  }

</style>
